module.exports = __webpack_public_path__ + "integration-stripe-logo.png?09aafa6172f5cf5e53c654d3c24325da";